<script setup lang="ts">
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import InputEmailQC from '@qicgroupdoha/qic-connect-ds/components/InputEmailQC'
  import ToggleQC from '@qicgroupdoha/qic-connect-ds/components/ToggleQC'
  import ContactsCheckbox from '@/shared/components/rebranding/ContactsCheckbox.vue'
  import VisitorsPhoneInput from '@/shared/components/rebranding/VisitorsPhoneInput/VisitorsPhoneInput.vue'
  import BlockTitle from './BlockTitle/BlockTitle.vue'
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import type { VisitorType, PhoneInfo } from '@/shared/types/store.types'
  import type { EmailDomain } from '@/shared/types/other.types'

  interface Props {
    visitor: VisitorType
    emailError: string[]
    emailIsValid: boolean
    filtredEmailDomains: EmailDomain[]
    emailDomainsLoading: boolean
    isHolder: boolean
    isEdit: boolean
    titleText: string
    titleMarginTop?: string
  }

  const { locale } = useI18n()

  const email = defineModel<string>('email', { required: true })
  const contactsSame = defineModel<boolean>('contactsSame', { required: true })

  defineProps<Props>()
  const emit = defineEmits<{
    (e: 'input-email', value: string | number | null): void
    (e: 'selected-domain', domain: string): void
    (e: 'phone-completed', value: boolean): void
    (e: 'phone-changed', value: PhoneInfo): void
  }>()

  const visitorsPhoneInput = ref<InstanceType<typeof VisitorsPhoneInput>>()
  defineExpose({ visitorsPhoneInput })
</script>

<template>
  <WrapperQC direction="column" gap="var(--spacing-5)" class="visitor-form__contacts">
    <BlockTitle
      icon="phone"
      :text="titleText"
      :style="titleMarginTop ? { marginTop: titleMarginTop } : undefined"
    />

    <ContactsCheckbox v-if="!isHolder">
      <template #toggle>
        <ToggleQC v-model="contactsSame" size="medium" data-test="contacts-toggle" />
      </template>
    </ContactsCheckbox>

    <InputEmailQC
      v-model="email"
      :label="$t('qic_user_contacts_email')"
      :errors="emailError"
      :is-valid="emailIsValid"
      name="email"
      :disabled="!isHolder && contactsSame"
      data-test="email-input"
      :domains-list="filtredEmailDomains"
      :locale="locale"
      :loading="emailDomainsLoading"
      @input="emit('input-email', $event)"
      @selected-domain="emit('selected-domain', $event)"
    />
    <VisitorsPhoneInput
      ref="visitorsPhoneInput"
      :visitor="visitor"
      :disabled="!isHolder && contactsSame"
      :contacts-same="contactsSame"
      :is-edit="isEdit"
      :is-holder="isHolder"
      @phone-completed="emit('phone-completed', $event)"
      @phone-changed="emit('phone-changed', $event)"
    />
  </WrapperQC>
</template>
